module.exports = __webpack_public_path__ + "img/link.11982414.svg";